module.exports = __webpack_public_path__ + "4f098aa50b53a576c2588df26798e978.svg";